import { toastNotify } from './toastNotify';

export const downloadFileFromURL = (actionURL) => {
  try {
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', actionURL);
    a.setAttribute('target', '_blank');
    a.setAttribute('download', actionURL);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    toastNotify('error', 'Something went wrong.');
  }
};
